var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRotateOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBAD3C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.9,15.2c0.9-1.8,1.7-3.5,2.6-5.3c1.1,0.5,2.1,1,3.2,1.6c-1.8,3.7-3.6,7.4-5.4,11.1 c-3.7-1.8-7.4-3.6-11.1-5.4c0.5-1.1,1-2.2,1.6-3.2c1.9,0.9,3.8,1.8,5.7,2.7c-2.4-5.5-8.8-11-17.4-10.9C14.3,5.8,6.4,11.9,4.4,21 c-1.8,8.2,2,16.8,9.7,21c4.3,2.3,8.8,2.9,13.5,1.8c4.7-1.1,8.4-3.7,11.3-7.6c1,0.7,1.9,1.4,2.9,2.1c-4.7,6.9-14.1,11.5-24.3,9 C7.9,44.8,0.8,36,0.3,26.1c-0.4-10.4,6-19.6,15.9-22.8c5.4-1.7,10.8-1.4,16,0.8C37.5,6.3,41.3,10.1,43.9,15.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotateOrange);
export default __webpack_public_path__ + "static/media/icon-rotate-orange.1b9344faa1b70914f865e863ccfea6ef.svg";
export { ForwardRef as ReactComponent };